import { ApiModel } from './api-model';
import { TranslationValue } from './translation-value';
import * as moment from 'moment';
import { Language } from './language';
import { ProgramArticlePictureETTValue } from './program-article-translation-value';

export class Translation extends ApiModel {

  id: number;
  elementExternalId: number;
  lockStatus: boolean;
  creationDate: TranslationValue;
  updatedDate: TranslationValue;
  longName: TranslationValue;
  shortName: TranslationValue;
  name: TranslationValue;
  picture: TranslationValue;
  pictures: ProgramArticlePictureETTValue[];
  pictogram: ProgramArticlePictureETTValue;
  toUpdate: boolean;
  languageId: number;
  language: Language;
  translationTypeId: number;
  translationTypeName: string;
  tooltipContent: string;
  updatedByUser: string;

  get lastUpdated(): TranslationValue {
    if (moment(this.updatedDate.value).year() > 1492) {
      return new TranslationValue(
        {
          value: moment(this.updatedDate.value).format('DD/MM/YYYY'),
          orderId: this.updatedDate.orderId
        }
      );
    } else if (moment(this.creationDate.value).year() > 1492) {
      return new TranslationValue(
        {
          value: moment(this.creationDate.value).format('DD/MM/YYYY'),
          orderId: this.creationDate.orderId
        }
      );
    } else {
      return null;
    }
  }

  constructor(data: any) {
    super(data);
    if (data.name) {
      this.name = new TranslationValue(data.name);
    }
    if (data.longName) {
      this.longName = new TranslationValue(data.longName);
    }
    if (data.shortName) {
      this.shortName = new TranslationValue(data.shortName);
    }
    if (data.language && data.language.id) {
      this.languageId = data.language.id;
    }
    this.updatedDate = new TranslationValue(this.updatedDate);
    this.creationDate = new TranslationValue(this.creationDate);
    this.toUpdate = false;
    this.tooltipContent = "Loading...";
    this.pictures = this.pictures.sort(function (a, b) { return a.pictureFormatId - b.pictureFormatId });

    // pop pictogram and insert into this.pictogram
    this.pictogram = this.pictures.pop();
    this.updatedByUser = data.updatedByUser === '' ? '' : 'Updated by ' + data.updatedByUser;
  }

  setSavedStatus() {
    this.toUpdate = false;
    this.shortName.modified = false;
    this.longName.modified = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/models/translation.ts